import React, { useState, useRef, useEffect, useContext } from 'react';
import axios from 'axios';
import { useLocation  } from 'react-router-dom';
import $ from 'jquery';
import { MyContext } from './MyContextProvider'; // Import your context
import { useParams,useNavigate  } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import JsBarcode from 'jsbarcode';
import QRCode from "qrcode";
import './DEBT_Exit_Strategy.css';

const DEBT_Exit_Strategy = (props) => {
  const didFetchRef = useRef(false);
  const initRef = useRef({ headerHandled: false, dataTableHandled: false });

  const { i18n } = useTranslation();
  const { t } = useTranslation();
  var location = useLocation();
  const { App_Data, setApp_Data } = useContext(MyContext); // Access the context
  const urlParams = new URLSearchParams(window.location.search);
  //setReturn_Path(urlParams.get('Return'));
  const navigate = useNavigate();

  const inputFontStyle = {
    fontFamily: 'sans-serif',
    fontSize: '16px',
    fontWeight: 'normal',
    fontStyle: 'normal',
    color: '#000'
  };


  const [newData, setNewData] = useState({
 	Source_Path:"DEBT_EXIT_STRATEGY",
    Status: App_Data.Status,
    Parameter: App_Data.Parameter,
    Search: App_Data.Search,
    Return_Path: App_Data.Return_Path,
    Return_ID: App_Data.ID,
    Return_Status: App_Data.Return_Status,
	Object_Text:";",
	DEBT_EXIT_STRATEGY:-1
  });


  const [DEBT_EXIT_STRATEGY, setDEBT_EXIT_STRATEGY] = React.useState(null);
  const [DEBT_EXIT_STRATEGY_D, setDEBT_EXIT_STRATEGY_D] = React.useState(null);



 
  useEffect(() => {
    document.title = "SRWAE | "+t('Debt Note Token Exit Strategy');  
	  
 
	if(location.hash=="#Return"){
		setNewData({ ...newData});
		setApp_Data({ ...newData})
		navigate('/DEBT_Exit_Strategy',{replace:true});
	}
	if(location.hash=="#New"){
		const collectClientInfo = () => {
		return {
			userAgent: navigator.userAgent,
			language: navigator.language,
			platform: navigator.platform,
			screenResolution: `${screen.width}x${screen.height}`,
			colorDepth: screen.colorDepth,
			timezoneOffset: new Date().getTimezoneOffset(),
			timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
			cookieEnabled: navigator.cookieEnabled,
			javaEnabled: navigator.javaEnabled(),
			online: navigator.onLine,
			referrer: document.referrer,
			locationHref: window.location.href,
			screenOrientation: screen.orientation?.type || 'unknown'
		  };
		};

		const clientInfo = collectClientInfo();
		handleLoadNewDEBT_EXIT_STRATEGY(clientInfo,"OpenNew");

		navigate('/DEBT_Exit_Strategy',{replace:true});
	}
	if(location.hash=="#Search"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/DEBT_Exit_Strategy_S',{replace:true});
	}
	if(location.hash=="#Update"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(DEBT_EXIT_STRATEGY));
		if(Temp_Data2.status!="New"){
			Temp_Data2.status = "UpToDate";
			handlePutDEBT_EXIT_STRATEGY(Temp_Data2);
		}else{
			Temp_Data2.status = "UpToDate";
			handlePostDEBT_EXIT_STRATEGY(Temp_Data2);
			const collectClientInfo = () => {
			  return {
				userAgent: navigator.userAgent,
				language: navigator.language,
				platform: navigator.platform,
				screenResolution: `${screen.width}x${screen.height}`,
				colorDepth: screen.colorDepth,
				timezoneOffset: new Date().getTimezoneOffset(),
				timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
				cookieEnabled: navigator.cookieEnabled,
				javaEnabled: navigator.javaEnabled(),
				online: navigator.onLine,
				referrer: document.referrer,
				locationHref: window.location.href,
				screenOrientation: screen.orientation?.type || 'unknown'
			  };
			};

			const clientInfo = collectClientInfo();
			handleLoadNewDEBT_EXIT_STRATEGY(clientInfo,"OpenNew");
		}
		navigate('/DEBT_Exit_Strategy',{replace:true});
	}
	if(location.hash=="#FormPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/DEBT_Exit_Strategy_P',{replace:true});
	}
	if(location.hash=="#SearchPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/DEBT_Exit_Strategy_S_P',{replace:true});
	}
	if(location.hash=="#Print"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/DEBT_Exit_Strategy_P',{replace:true});
	}
	if(location.hash=="#Delete"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(DEBT_EXIT_STRATEGY));
		if(Temp_Data2.status!="New"){
			handleDeleteDEBT_EXIT_STRATEGY(Temp_Data2);
			navigate('/DEBT_Exit_Strategy#New',{replace:true});
		} 
		else 
			navigate('/DEBT_Exit_Strategy',{replace:true});
	}
	if(location.hash=="#Export"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/DEBT_Exit_Strategy',{replace:true});
	}
	if(location.hash=="#Import"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/DEBT_Exit_Strategy',{replace:true});
	}
	if(location.hash=="#Help"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/DEBT_Exit_Strategy',{replace:true});
	}
	if(location.hash=="#LogInLogOut"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/DEBT_Exit_Strategy',{replace:true});
	}


  }, [location.hash]);   // Use cleanup for location.hash such as }, [location.hash]);



  useEffect(() => {
	  
	    if (!DEBT_EXIT_STRATEGY) return;

    if (!initRef.current.headerHandled) {
	  for (let i = 1; i <= 10; i++) {
	  const sectionId = `#DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_${i}_SECTION`;
	  const headerId = `#DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_${i}_HEADER`;

	  if ($(sectionId).length && $(headerId).length) {
		
		const hiddenSections = [0];
		if (hiddenSections.includes(i)) {
		  $(sectionId).hide();
		} else {
		  $(sectionId).show();
		}

		$(headerId).off("click").on("click", function () {
		  $(sectionId).slideToggle();

		  const icon = $(this).find(".toggle-icon");
		  const current = icon.text().trim();

		  if (current === "v") {
			icon.text("^");
		  } else {
			icon.text("v");
		  }
		});
	  }
	}
      initRef.current.headerHandled = true;
  }


  if (!initRef.current.dataTableHandled) {

    initRef.current.dataTableHandled = true;
  }  

  }, [DEBT_EXIT_STRATEGY]) ;


  
  
  var Ids = [];
  for(var Ele in DEBT_EXIT_STRATEGY){
	  for(var Sec in DEBT_EXIT_STRATEGY[Ele]){
		if(Sec == "id")
			Ids.push(DEBT_EXIT_STRATEGY[Ele]["id"]);
		else if(Sec == "status")
			Ids.push(DEBT_EXIT_STRATEGY[Ele]["status"]);
		else if(Array.isArray(DEBT_EXIT_STRATEGY[Ele][Sec]))
			  for(var Row in DEBT_EXIT_STRATEGY[Ele][Sec])  // Convert to DEBT_EXIT_STRATEGY[Ele][Sec].forEach((row) => { ... })
				for (var Id in Row) 
					Ids.push(Id);
		else
			for (var Id in DEBT_EXIT_STRATEGY[Ele][Sec]) 
				Ids.push(Id);
	  }
  }
  const [isValid, setIsValid] = useState(Object.fromEntries(Ids.map(key => [key, true])));
   
   
  React.useEffect(() => {
	if (didFetchRef.current) return;
    didFetchRef.current = true;

	var Temp_Data= JSON.parse(JSON.stringify(App_Data));
	Temp_Data["DEBT_EXIT_STRATEGY"] = 0;
	setApp_Data({...Temp_Data})

	const collectClientInfo = () => {
	  return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown',
	  };
	};
	const baseClientInfo = collectClientInfo();
	handleLoadNewDEBT_EXIT_STRATEGY(baseClientInfo,"FirstLoad");
 
/*	axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/DEBT_EXIT_STRATEGY`).then((response1) => {
		if(!DEBT_EXIT_STRATEGY) 
			setDEBT_EXIT_STRATEGY(JSON.parse(JSON.stringify(response1.data)));
		axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/DEBT_EXIT_STRATEGY_D`).then((response2) => {
			setDEBT_EXIT_STRATEGY_D( JSON.parse(JSON.stringify(response2.data)));
			handleAddDEBT_EXIT_STRATEGY_Load_Add_New(response1.data,response2.data);
		});
    });
*/

	//$('#navbarNav1').hide();
//$('#navbarNav6').hide();

  }, []);


 const handleLoadNewDEBT_EXIT_STRATEGY = async (clientInfo, status) => {
	axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/DEBT_EXIT_STRATEGY/New', {clientInfo, clientStamp: Date.now(), status:status})
	  .then(response => {
		setDEBT_EXIT_STRATEGY(response.data);
	  })
	  .catch(error => {
		console.error('Error sending client info:', error);
	  });
  };



   

 const handleLastDataDEBT_EXIT_STRATEGY = async (data) => {
	const collectClientInfo = () => {
	return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown'
	  };
	};
	
	const clientInfo = collectClientInfo();

    fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/DEBT_EXIT_STRATEGY/Status', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ data: data, clientInfo:clientInfo , stamp: Date.now() })
    }).catch(err => {
      console.error("Error", err);
    });
  };


  const handlePutDEBT_EXIT_STRATEGY = async (Updated) => {
    try {
		axios.put('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/DEBT_EXIT_STRATEGY/', Updated);
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
  
  const handlePostDEBT_EXIT_STRATEGY = async (Updated) => {
    try {
		axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/DEBT_EXIT_STRATEGY', Updated);
    } catch (error) {
      console.error('Error adding post:', error);
    }
  };
 
   
 

  const handleDeleteDEBT_EXIT_STRATEGY = async (Updated) => {
    try {
		console.log(JSON.stringify(Updated));
		axios.delete('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/DEBT_EXIT_STRATEGY', {
            data: Updated,
            headers: {
                'Content-Type': 'application/json' 
			    }
            });
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
     
const DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_1_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_1_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(DEBT_EXIT_STRATEGY));
	Temp_Data["1"]["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_1_0"]=value;
	//handleAddDEBT_EXIT_STRATEGY(Temp_Data,App_Data['DEBT_EXIT_STRATEGY']);
	Form_Data_onChange("1","DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_1_0",value,Temp_Data);
 	//handleLastDataDEBT_EXIT_STRATEGY(Temp_Data);
    setDEBT_EXIT_STRATEGY(Temp_Data);
 }; 
  
    
const DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_1_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_1_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(DEBT_EXIT_STRATEGY));
	Temp_Data["1"]["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_1_1"]=value;
	//handleAddDEBT_EXIT_STRATEGY(Temp_Data,App_Data['DEBT_EXIT_STRATEGY']);
	Form_Data_onChange("1","DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_1_1",value,Temp_Data);
 	//handleLastDataDEBT_EXIT_STRATEGY(Temp_Data);
    setDEBT_EXIT_STRATEGY(Temp_Data);
 }; 
  
    
const DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_1_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_1_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(DEBT_EXIT_STRATEGY));
	Temp_Data["1"]["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_1_2"]=value;
	//handleAddDEBT_EXIT_STRATEGY(Temp_Data,App_Data['DEBT_EXIT_STRATEGY']);
	Form_Data_onChange("1","DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_1_2",value,Temp_Data);
 	//handleLastDataDEBT_EXIT_STRATEGY(Temp_Data);
    setDEBT_EXIT_STRATEGY(Temp_Data);
 }; 
  

const DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_1_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_1_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(DEBT_EXIT_STRATEGY));
	Temp_Data["1"]["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_1_3"]=value;
	Form_Data_onChange("1","DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_1_3",value,Temp_Data);
 	//handleLastDataDEBT_EXIT_STRATEGY(Temp_Data);
    setDEBT_EXIT_STRATEGY(Temp_Data);
	//handleAddDEBT_EXIT_STRATEGY(Temp_Data,App_Data['DEBT_EXIT_STRATEGY']);
  }; 
  

    
const DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_2_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_2_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(DEBT_EXIT_STRATEGY));
	Temp_Data["2"]["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_2_0"]=value;
	//handleAddDEBT_EXIT_STRATEGY(Temp_Data,App_Data['DEBT_EXIT_STRATEGY']);
	Form_Data_onChange("2","DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_2_0",value,Temp_Data);
 	//handleLastDataDEBT_EXIT_STRATEGY(Temp_Data);
    setDEBT_EXIT_STRATEGY(Temp_Data);
 }; 
  
    
const DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_2_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_2_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(DEBT_EXIT_STRATEGY));
	Temp_Data["2"]["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_2_1"]=value;
	//handleAddDEBT_EXIT_STRATEGY(Temp_Data,App_Data['DEBT_EXIT_STRATEGY']);
	Form_Data_onChange("2","DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_2_1",value,Temp_Data);
 	//handleLastDataDEBT_EXIT_STRATEGY(Temp_Data);
    setDEBT_EXIT_STRATEGY(Temp_Data);
 }; 
  
    
const DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_2_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_2_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(DEBT_EXIT_STRATEGY));
	Temp_Data["2"]["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_2_2"]=value;
	//handleAddDEBT_EXIT_STRATEGY(Temp_Data,App_Data['DEBT_EXIT_STRATEGY']);
	Form_Data_onChange("2","DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_2_2",value,Temp_Data);
 	//handleLastDataDEBT_EXIT_STRATEGY(Temp_Data);
    setDEBT_EXIT_STRATEGY(Temp_Data);
 }; 
  
  
      
const DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_3_0_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_3_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(DEBT_EXIT_STRATEGY));
	Temp_Data["3"]["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_3_0"]=value ? true : false; // optionally just use boolean
	//handleAddDEBT_EXIT_STRATEGY(Temp_Data,App_Data['DEBT_EXIT_STRATEGY']);
	Form_Data_onChange("3","DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_3_0",value,Temp_Data);
 	//handleLastDataDEBT_EXIT_STRATEGY(Temp_Data);
    setDEBT_EXIT_STRATEGY(Temp_Data);
 }; 
  


  
      
const DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_3_1_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_3_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(DEBT_EXIT_STRATEGY));
	Temp_Data["3"]["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_3_1"]=value ? true : false; // optionally just use boolean
	//handleAddDEBT_EXIT_STRATEGY(Temp_Data,App_Data['DEBT_EXIT_STRATEGY']);
	Form_Data_onChange("3","DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_3_1",value,Temp_Data);
 	//handleLastDataDEBT_EXIT_STRATEGY(Temp_Data);
    setDEBT_EXIT_STRATEGY(Temp_Data);
 }; 
  


  
      
const DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_3_2_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_3_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(DEBT_EXIT_STRATEGY));
	Temp_Data["3"]["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_3_2"]=value ? true : false; // optionally just use boolean
	//handleAddDEBT_EXIT_STRATEGY(Temp_Data,App_Data['DEBT_EXIT_STRATEGY']);
	Form_Data_onChange("3","DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_3_2",value,Temp_Data);
 	//handleLastDataDEBT_EXIT_STRATEGY(Temp_Data);
    setDEBT_EXIT_STRATEGY(Temp_Data);
 }; 
  


    
const DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_4_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_4_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(DEBT_EXIT_STRATEGY));
	Temp_Data["4"]["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_4_0"]=value;
	//handleAddDEBT_EXIT_STRATEGY(Temp_Data,App_Data['DEBT_EXIT_STRATEGY']);
	Form_Data_onChange("4","DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_4_0",value,Temp_Data);
 	//handleLastDataDEBT_EXIT_STRATEGY(Temp_Data);
    setDEBT_EXIT_STRATEGY(Temp_Data);
 }; 
  
    
const DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(DEBT_EXIT_STRATEGY));
	Temp_Data["5"]["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_0"]=value;
	//handleAddDEBT_EXIT_STRATEGY(Temp_Data,App_Data['DEBT_EXIT_STRATEGY']);
	Form_Data_onChange("5","DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_0",value,Temp_Data);
 	//handleLastDataDEBT_EXIT_STRATEGY(Temp_Data);
    setDEBT_EXIT_STRATEGY(Temp_Data);
 }; 
  
    
const DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(DEBT_EXIT_STRATEGY));
	Temp_Data["5"]["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_1"]=value;
	//handleAddDEBT_EXIT_STRATEGY(Temp_Data,App_Data['DEBT_EXIT_STRATEGY']);
	Form_Data_onChange("5","DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_1",value,Temp_Data);
 	//handleLastDataDEBT_EXIT_STRATEGY(Temp_Data);
    setDEBT_EXIT_STRATEGY(Temp_Data);
 }; 
  
    
const DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(DEBT_EXIT_STRATEGY));
	Temp_Data["5"]["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_2"]=value;
	//handleAddDEBT_EXIT_STRATEGY(Temp_Data,App_Data['DEBT_EXIT_STRATEGY']);
	Form_Data_onChange("5","DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_2",value,Temp_Data);
 	//handleLastDataDEBT_EXIT_STRATEGY(Temp_Data);
    setDEBT_EXIT_STRATEGY(Temp_Data);
 }; 
  
    
const DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(DEBT_EXIT_STRATEGY));
	Temp_Data["5"]["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_3"]=value;
	//handleAddDEBT_EXIT_STRATEGY(Temp_Data,App_Data['DEBT_EXIT_STRATEGY']);
	Form_Data_onChange("5","DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_3",value,Temp_Data);
 	//handleLastDataDEBT_EXIT_STRATEGY(Temp_Data);
    setDEBT_EXIT_STRATEGY(Temp_Data);
 }; 
  

const DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(DEBT_EXIT_STRATEGY));
	Temp_Data["5"]["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_4"]=value;
	Form_Data_onChange("5","DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_4",value,Temp_Data);
 	//handleLastDataDEBT_EXIT_STRATEGY(Temp_Data);
    setDEBT_EXIT_STRATEGY(Temp_Data);
	//handleAddDEBT_EXIT_STRATEGY(Temp_Data,App_Data['DEBT_EXIT_STRATEGY']);
  }; 
  

    
const DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_5_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_5"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(DEBT_EXIT_STRATEGY));
	Temp_Data["5"]["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_5"]=value;
	//handleAddDEBT_EXIT_STRATEGY(Temp_Data,App_Data['DEBT_EXIT_STRATEGY']);
	Form_Data_onChange("5","DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_5",value,Temp_Data);
 	//handleLastDataDEBT_EXIT_STRATEGY(Temp_Data);
    setDEBT_EXIT_STRATEGY(Temp_Data);
 }; 
  

const DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_9_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_9_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(DEBT_EXIT_STRATEGY));
	Temp_Data["9"]["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_9_0"]=value;
	Form_Data_onChange("9","DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_9_0",value,Temp_Data);
 	//handleLastDataDEBT_EXIT_STRATEGY(Temp_Data);
    setDEBT_EXIT_STRATEGY(Temp_Data);
	//handleAddDEBT_EXIT_STRATEGY(Temp_Data,App_Data['DEBT_EXIT_STRATEGY']);
  }; 
  

    
const DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_9_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_9_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(DEBT_EXIT_STRATEGY));
	Temp_Data["9"]["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_9_1"]=value;
	//handleAddDEBT_EXIT_STRATEGY(Temp_Data,App_Data['DEBT_EXIT_STRATEGY']);
	Form_Data_onChange("9","DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_9_1",value,Temp_Data);
 	//handleLastDataDEBT_EXIT_STRATEGY(Temp_Data);
    setDEBT_EXIT_STRATEGY(Temp_Data);
 }; 
  
    
const DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_9_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_9_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(DEBT_EXIT_STRATEGY));
	Temp_Data["9"]["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_9_2"]=value;
	//handleAddDEBT_EXIT_STRATEGY(Temp_Data,App_Data['DEBT_EXIT_STRATEGY']);
	Form_Data_onChange("9","DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_9_2",value,Temp_Data);
 	//handleLastDataDEBT_EXIT_STRATEGY(Temp_Data);
    setDEBT_EXIT_STRATEGY(Temp_Data);
 }; 
  
    
const DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_9_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_9_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(DEBT_EXIT_STRATEGY));
	Temp_Data["9"]["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_9_3"]=value;
	//handleAddDEBT_EXIT_STRATEGY(Temp_Data,App_Data['DEBT_EXIT_STRATEGY']);
	Form_Data_onChange("9","DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_9_3",value,Temp_Data);
 	//handleLastDataDEBT_EXIT_STRATEGY(Temp_Data);
    setDEBT_EXIT_STRATEGY(Temp_Data);
 }; 
  
    
const DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_9_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_9_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(DEBT_EXIT_STRATEGY));
	Temp_Data["9"]["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_9_4"]=value;
	//handleAddDEBT_EXIT_STRATEGY(Temp_Data,App_Data['DEBT_EXIT_STRATEGY']);
	Form_Data_onChange("9","DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_9_4",value,Temp_Data);
 	//handleLastDataDEBT_EXIT_STRATEGY(Temp_Data);
    setDEBT_EXIT_STRATEGY(Temp_Data);
 }; 
  


 
const Form_Data_onChange = (Sec,ID,Value,Temp_Data) => {

};

  if (!DEBT_EXIT_STRATEGY) return <div>Loading...</div>;;

   const handleSingleClick = (event,ID) => {
	$(event.currentTarget).siblings().removeClass('selected');
    event.currentTarget.classList.toggle('selected');
   };


   const handleDoubleClick = (event,ID) => {
    const selectedRowId = event.currentTarget.id.replace("TR","");
    //newData.Return_Data=selectedRowId;
	setNewData({ ...newData});
	setApp_Data(newData)
    window.location.hash = 'Return';
   };

const handleAddRow = (Sec) => {
  const newRow = {};
  switch(Sec) {

  }


  const updatedDEBT_EXIT_STRATEGY =JSON.parse(JSON.stringify(DEBT_EXIT_STRATEGY));
  updatedDEBT_EXIT_STRATEGY[Sec] = [...updatedDEBT_EXIT_STRATEGY[Sec], newRow];
  setDEBT_EXIT_STRATEGY(updatedDEBT_EXIT_STRATEGY);
};

const handleDeleteRow = (sec,index) => {
  const updatedDEBT_EXIT_STRATEGY = JSON.parse(JSON.stringify(DEBT_EXIT_STRATEGY));
  updatedDEBT_EXIT_STRATEGY[sec].splice(index, 1);
  setDEBT_EXIT_STRATEGY(updatedDEBT_EXIT_STRATEGY);
}; 

 const print_Canvas = async (ID) => {
const canvas = document.getElementById(ID);
const imgData = canvas.toDataURL("image/png");

const printWindow = window.open('', '_blank');
printWindow.document.write(`
  <html>
    <head><title>Print</title></head>
    <body style="margin:0">
      <img src="${imgData}" style="width:100%;"/>
      <script>
        window.onload = function() {
          window.print();
          window.onafterprint = function() {
            window.close();
          };
        };
      </script>
    </body>
  </html>
`);
printWindow.document.close();
}
  return <>
			<nav className="navbar navbar-expand-lg navbar-light bg-light">
			 <div style={{ padding: '10px 20px', fontSize: '1.5rem', fontWeight: 'bold' }}>
  {t(`Debt Note Token Exit Strategy`)}
  <hr style={{ marginTop: '8px', borderTop: '2px solid #007bff', width: '100%' }} />
</div>
			 <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
				aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
			 <span className="navbar-toggler-icon"></span>
			 </button>
			 <div className="collapse navbar-collapse" id="navbarNav">
				<ul className="navbar-nav">
				   <li className="nav-item active">
					  <a  id="navbarNav2" className="nav-link" href="#New">{t(`New`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav3" className="nav-link" href="#Search">{t(`Search`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav4" className="nav-link" href="#Update">{t(`Update`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav8" className="nav-link" href="#Delete">{t(`Delete`)}</a>
				   </li>
				</ul>
			 </div>
		  </nav>	
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_1_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Debt Note Token Exit Strategy ID`)} <span className="toggle-icon">^</span></h2>
            <div id="DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_1_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`DEBT Exit Strategy ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_1_0" type="text" className="form-control" placeholder="DEBT Exit Strategy ID" value={DEBT_EXIT_STRATEGY["1"][`DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_1_0`]} 
						onChange={DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_1_0_Change} style={{ ...inputFontStyle, borderColor: isValid["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_1_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter DEBT Exit Strategy ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Asset ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_1_1" type="text" className="form-control" placeholder="Asset ID" value={DEBT_EXIT_STRATEGY["1"][`DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_1_1`]} 
						onChange={DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_1_1_Change} style={{ ...inputFontStyle, borderColor: isValid["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_1_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Asset ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Offering ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_1_2" type="text" className="form-control" placeholder="Offering ID" value={DEBT_EXIT_STRATEGY["1"][`DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_1_2`]} 
						onChange={DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_1_2_Change} style={{ ...inputFontStyle, borderColor: isValid["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_1_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Offering ID`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Primary Exit Strategy`)}
					 </div>
                     <div className="card-body" >
                        <select id="DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_1_3"  value={DEBT_EXIT_STRATEGY["1"][`DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_1_3`]} onChange={DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_1_3_Change} className="form-control" name="Primary Exit Strategy"  >
						  <option value="Hold for Income">Hold for Income</option>
						  <option value="Sale">Sale</option>
						  <option value="Refinance">Refinance</option>
						  <option value="Buyback">Buyback</option>
						  <option value="Development Completion and Sale">Development Completion and Sale</option>
						  <option value="Auction Resale">Auction Resale</option>
						  <option value="Token Holder Vote">Token Holder Vote</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Primary Exit Strategy
				     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_2_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Expected Hold Period Months`)} <span className="toggle-icon">^</span></h2>
            <div id="DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_2_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '50ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Expected Hold Period Months`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_2_0" type="text" className="form-control" placeholder="Expected Hold Period Months" value={DEBT_EXIT_STRATEGY["2"][`DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_2_0`]} 
						onChange={DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_2_0_Change} style={{ ...inputFontStyle, borderColor: isValid["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_2_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '50ch' }}>
						 {t(`Enter Expected Hold Period Months`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Target Sale Price USD`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_2_1" type="text" className="form-control" placeholder="Target Sale Price USD" value={DEBT_EXIT_STRATEGY["2"][`DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_2_1`]} 
						onChange={DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_2_1_Change} style={{ ...inputFontStyle, borderColor: isValid["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_2_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Target Sale Price USD`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '25ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Target IRR`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_2_2" type="text" className="form-control" placeholder="Target IRR" value={DEBT_EXIT_STRATEGY["2"][`DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_2_2`]} 
						onChange={DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_2_2_Change} style={{ ...inputFontStyle, borderColor: isValid["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_2_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '25ch' }}>
						 {t(`Enter Target IRR`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_3_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Refinance Allowed`)} <span className="toggle-icon">^</span></h2>
            <div id="DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_3_SECTION" className="row">
			                 {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_3_0" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Refinance Allowed`)} <input id="DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_3_0" type="checkbox" style={{ marginLeft: '5px' }}  onChange={DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_3_0_Change} 
					  checked={DEBT_EXIT_STRATEGY?.["3"]?.["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_3_0"] === "true" || DEBT_EXIT_STRATEGY?.["3"]?.["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_3_0"] === true} />
					</label>
                  </div>
               </div>
               {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_3_1" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Buyback Option Allowed`)} <input id="DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_3_1" type="checkbox" style={{ marginLeft: '5px' }}  onChange={DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_3_1_Change} 
					  checked={DEBT_EXIT_STRATEGY?.["3"]?.["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_3_1"] === "true" || DEBT_EXIT_STRATEGY?.["3"]?.["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_3_1"] === true} />
					</label>
                  </div>
               </div>
               {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_3_2" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Token Holder Vote Required`)} <input id="DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_3_2" type="checkbox" style={{ marginLeft: '5px' }}  onChange={DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_3_2_Change} 
					  checked={DEBT_EXIT_STRATEGY?.["3"]?.["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_3_2"] === "true" || DEBT_EXIT_STRATEGY?.["3"]?.["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_3_2"] === true} />
					</label>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_4_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Exit Waterfall Text`)} <span className="toggle-icon">^</span></h2>
            <div id="DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_4_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '4000ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Exit Waterfall Text`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_4_0" type="text" className="form-control" placeholder="Exit Waterfall Text" value={DEBT_EXIT_STRATEGY["4"][`DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_4_0`]} 
						onChange={DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_4_0_Change} style={{ ...inputFontStyle, borderColor: isValid["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_4_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '4000ch' }}>
						 {t(`Enter Exit Waterfall Text`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Submitted By`)} <span className="toggle-icon">^</span></h2>
            <div id="DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Submitted By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_0" type="text" className="form-control" placeholder="Submitted By" value={DEBT_EXIT_STRATEGY["5"][`DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_0`]} 
						onChange={DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_0_Change} style={{ ...inputFontStyle, borderColor: isValid["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Submitted By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Submitted At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_1" type="text" className="form-control" placeholder="Submitted At" value={DEBT_EXIT_STRATEGY["5"][`DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_1`]} 
						onChange={DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_1_Change} style={{ ...inputFontStyle, borderColor: isValid["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Submitted At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Reviewed By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_2" type="text" className="form-control" placeholder="Reviewed By" value={DEBT_EXIT_STRATEGY["5"][`DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_2`]} 
						onChange={DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_2_Change} style={{ ...inputFontStyle, borderColor: isValid["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Reviewed By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Reviewed At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_3" type="text" className="form-control" placeholder="Reviewed At" value={DEBT_EXIT_STRATEGY["5"][`DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_3`]} 
						onChange={DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_3_Change} style={{ ...inputFontStyle, borderColor: isValid["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Reviewed At`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Approval Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_4"  value={DEBT_EXIT_STRATEGY["5"][`DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_4`]} onChange={DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_4_Change} className="form-control" name="Approval Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Submitted">Submitted</option>
						  <option value="Under Review">Under Review</option>
						  <option value="Revision Requested">Revision Requested</option>
						  <option value="Approved">Approved</option>
						  <option value="Rejected">Rejected</option>
						  <option value="Withdrawn">Withdrawn</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Approval Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '3000ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Approval Notes`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_5" type="text" className="form-control" placeholder="Approval Notes" value={DEBT_EXIT_STRATEGY["5"][`DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_5`]} 
						onChange={DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_5_Change} style={{ ...inputFontStyle, borderColor: isValid["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_5_5"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '3000ch' }}>
						 {t(`Enter Approval Notes`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_9_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Record Status`)} <span className="toggle-icon">^</span></h2>
            <div id="DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_9_SECTION" className="row">
			                {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Record Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_9_0"  value={DEBT_EXIT_STRATEGY["9"][`DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_9_0`]} onChange={DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_9_0_Change} className="form-control" name="Record Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Active">Active</option>
						  <option value="Inactive">Inactive</option>
						  <option value="Archived">Archived</option>
						  <option value="Deleted">Deleted</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Record Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_9_1" type="text" className="form-control" placeholder="Created By" value={DEBT_EXIT_STRATEGY["9"][`DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_9_1`]} 
						onChange={DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_9_1_Change} style={{ ...inputFontStyle, borderColor: isValid["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_9_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Created By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_9_2" type="text" className="form-control" placeholder="Created At" value={DEBT_EXIT_STRATEGY["9"][`DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_9_2`]} 
						onChange={DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_9_2_Change} style={{ ...inputFontStyle, borderColor: isValid["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_9_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Created At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_9_3" type="text" className="form-control" placeholder="Updated By" value={DEBT_EXIT_STRATEGY["9"][`DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_9_3`]} 
						onChange={DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_9_3_Change} style={{ ...inputFontStyle, borderColor: isValid["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_9_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Updated By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_9_4" type="text" className="form-control" placeholder="Updated At" value={DEBT_EXIT_STRATEGY["9"][`DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_9_4`]} 
						onChange={DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_9_4_Change} style={{ ...inputFontStyle, borderColor: isValid["DEBT_NOTE_06_LIFECYCLE_DEFAULT_MATURITY_EXIT_DEBT_EXIT_STRATEGY_9_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Updated At`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>

  </>;
};

export default DEBT_Exit_Strategy;  